module.exports = __webpack_public_path__ + "img/tbt830-1993.asm.0562de4b.jpg";